import { StyledButton, StyledPhoneBox } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({ color, children, onClick }: ButtonProps) => (
  <StyledButton color={color} onClick={onClick}>
    {children}
  </StyledButton>
);

export const phoneNumberBox = ({ color, children, onClick }: ButtonProps) => (
  <StyledPhoneBox color={color} onClick={onClick}>
    {children}
  </StyledPhoneBox>
);
